import { AlertCircle } from 'lucide-react'

import { Alert } from '@/components/ui/alert'

interface Props {
  errors: string[]
}

export const ValidationBanner = ({ errors }: Props) => (
  <Alert variant="destructive">
    <AlertCircle />
    <ul className="space-y-0.5">
      {errors.map((e, i) => (
        <li key={i}>{e}</li>
      ))}
    </ul>
  </Alert>
)
